import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router-dom";
import ForgetPassword from "@view/landing/forgetPaaword/ForgetPassword";
import Login from "./login/Login";

import "./Landing.scss";
import "./Landing-resizes.scss";
import "./Landing-animations.scss";
import { useMst } from "@store/Route";
import { RouteComponentProps } from "react-router";
import ButtonLoader from "@components/ButtonLoader/ButtonLoader";
import { checkExtToken } from "@utils/validation";
import bgLanding from "@img/views/landing/bg-landing.png";
import kayeLogo from "@img/ui/kaye-logo.png";
import worldAmericanAcademyLogo from "@img/ui/world-american-academy.png";
import { Fade, Zoom } from "@mui/material";

const Landing = observer((props: RouteComponentProps) => {
  const [animOnboard, setAnimOnboard] = useState(true);
  const [isWorldAmericanAcademy, setIsWorldAmericanAcademy] = useState(false);

  const { landing } = useMst();
  const { errorMsg } = landing;
  const history = useHistory();
  const { toggleShowPasswordPanel, token, exp, setInitial, deleteToken } =
    landing;

  useEffect(() => {
    if (!token || !exp || checkExtToken(exp)) {
      props.history.push("/");
      setInitial();
      deleteToken();
    }
    const url = window.location.href;
    if (
      url.includes("xwa.lingweitpt") ||
      url.includes("xcl.lingweitpt") ||
      url.includes("xaa.lingweitpt")
    ) {
      setIsWorldAmericanAcademy(true);
    }
  }, [token]);

  return (
    <div>
      <img
        className="fixed bg-[#5fc5ff] object-cover w-full h-screen inset-x-0 bottom-0 "
        src={bgLanding}
        alt="bg-landing"
      />

      <div className="flex flex-column items-center absolute  w-full md:h-full">
        <div className="w-full p-10">
          {isWorldAmericanAcademy ? (
            <img
              className="w-[160px]"
              src={worldAmericanAcademyLogo}
              alt="bg-landing"
            />
          ) : (
            <img className="w-[80px]" src={kayeLogo} alt="bg-landing" />
          )}
        </div>
        <Fade in={true} timeout={{ enter: 1000 }}>
          <div className="flex flex-column justify-center h-full">
            <div className="flex flex-col h-full justify-center m-10 ">
              {landing.status && landing.status !== 200 ? (
                <div className="pl-3 pr-3 w-full">
                  <div className="formElements__error">
                    <span>{errorMsg || "Email And Password Wrong"}</span>
                  </div>
                </div>
              ) : null}
              <div
                className={`row no-gutters mb-3 formElements__error ${"d-none"}`}
              >
                <span className="d-none float-right header--14  cursor--pointer">
                  Activate
                </span>
              </div>
              <div className="flex flex-wrap flex-row-reverse justify-center bg-white space-between  md:m-0 py-[40px] px-[30px]">
                <div className="max-w-[350px] lg:ml-14 ">
                  {toggleShowPasswordPanel ? (
                    <ForgetPassword />
                  ) : (
                    <Login {...props} />
                  )}
                </div>
                <div className=" flex flex-col justify-between max-w-[350px] mt-10 lg:mt-0">
                  <div>
                    <h1 className="actions__header ">
                      New to XCL?
                      <br />
                      Create an account today
                    </h1>
                    <p className="w-full">
                      Register your child for our safe and trusted school bus
                      service to and from their schools
                    </p>
                  </div>
                  <div>
                    <ButtonLoader
                      type="button"
                      className="actions__btnRegister w-full "
                      onClick={() => {
                        history.push("/register");
                      }}
                    >
                      Register now
                    </ButtonLoader>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
});

export default Landing;
